import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 10,
  },
  card: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: 26,
    marginBottom: 30
  },
  title: {
    fontSize: '22px',

  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1rem',
    width: '100%',
  },
  button: {
    marginTop: '1rem',
    borderRadius: 8,
    width: '100%',
  },
  numberFieldIcon: {
    width: '10%',
    color: '#48AC98',
    lineHeight: 0,
  },
  numberFieldCode: {
    width: '15%',
  },
  numberFieldWhatsapp: {
    width: '85%',
    textAlign: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
  },
  total: {
    padding: '16px',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  },
  productNameWithDescription: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  }
});